export const PIN_LIMIT = 5;
export const ALERT_AUTO_DISMISS_MS = 5000;

export const canUserPinActivity = (currentUser) => {
  if (!currentUser) {
    return false;
  }
  const roleName = currentUser.role?.name;
  return currentUser.admin || roleName === "admin" || roleName === "staff";
};
